import React from "react";
import { useLocation } from "react-router-dom";
import RootSearch from "container/search/RootSearch";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import { getQueryObjFromUrl } from "lib/urlQueryParser";

function SearchPage(props) {
  const location = useLocation();
  const query = getQueryObjFromUrl(location.search);

  return (
    <AppUpdateCheckpoint>
      <RootSearch searchQry={{ ...query }} />
    </AppUpdateCheckpoint>
  );
}

export default SearchPage;
